export default [  
  {
    path: '/products',
    name: 'products',
    component: () => import('@/views/modules/products/list'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Products List',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Products' }
      ]
    },
    children:[
      {
        path: '/products/create',
        name: 'products-create',
        component: () => import('@/views/modules/products/create'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Product Create',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Products', link: '/products' },
            { text: 'Create' }
          ]
        }
      },
      {
        path: '/products/:id/edit',
        props: true,
        name: 'products-edit',
        component: () => import('@/views/modules/products/edit'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Products Edit',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Product',  to: { name: "products-show" }, param: 'id' },
            { text: 'Edit' }
          ]
        }
      },
      {
        path: '/products/:id/show',
        props: true,
        name: 'products-show',
        component: () => import('@/views/modules/products/show'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Products Details',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Products',  to: { name: "products" } },
            { text: 'Details' }
          ]
        }
      },
    
    ]
  },
  {
    path: '/products-pricing',
    name: 'products-pricing',
    component: () => import('@/views/modules/products/pricing'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Pricing List',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Pricing' }
      ]
    },
  }
 
]